import sanitizeHtml from "sanitize-html";

interface FormattedTextWithLinkProps {
    rawText: string;
    href: string;
    textHighlightClass?: string;
    class?: string;
    openInNewTab?: boolean;
}

export const FormattedTextWithLink = (props: FormattedTextWithLinkProps) => {
    const newTabAttrs = props.openInNewTab ? `target="_blank" rel="noopener noreferrer"` : "";

    const textWithHref = props.rawText.replace(
        /<a>/g,
        `<a href="${props.href}" ${newTabAttrs} class="${props.textHighlightClass}">`
    );

    const sanitizedText = sanitizeHtml(textWithHref, {
        allowedTags: ["a"],
        allowedAttributes: {
            a: ["href", "class", "target", "rel"],
        },
    });
    return (
        <p
            className={props.class}
            dangerouslySetInnerHTML={{ __html: sanitizedText }}
        />
    );
};
